/**
 * This file is used to define functions that
 * persist and load the product factory state
 * to and from indexedDB.
 */

import {
  newSession,
  retrieveStorageById,
  patchStorage,
} from '../../../common/src/services/localForageService';

export const persistState = async <T>(
  dbName: string,
  storeName: string,
  sessionId: string,
  rootState: T,
): Promise<unknown> => {
  const storage = await retrieveStorageById(dbName, storeName, sessionId);
  if (!storage) {
    await newSession(dbName, storeName, sessionId);
  }
  return patchStorage(dbName, storeName, sessionId, rootState);
};

export const loadState = async <T>(
  dbName: string,
  storeName: string,
  sessionId: string,
): Promise<T | null> => {
  const dataObject = await retrieveStorageById<T>(dbName, storeName, sessionId);
  return dataObject;
};
